import { useCallback } from 'react';

import { viewItem } from 'services/avo';
import { useTrackEvent } from 'services/datalayer/hooks';
import { TicketFragment } from 'types/api/tickets.types';

import { useTicketInfoLookup } from 'components/@tickets/hooks';

import { useEventBundle } from './useEventBundle';
import { mapTicketToDataLayer } from './utils';

export const useTrackViewItem = () => {
  const eventBundle = useEventBundle();
  const lookup = useTicketInfoLookup();

  const track = useTrackEvent({
    trackFn: viewItem,
    variables: eventBundle,
  });

  return useCallback(
    (ticket: TicketFragment) => {
      const { discountedPrice, originalPrice } = lookup(ticket.id);
      track({
        items: [
          mapTicketToDataLayer(ticket, eventBundle, {
            discountedPrice,
            originalPrice,
          }),
        ],
        currency: 'SAR',
        value: discountedPrice?.amount ?? 0,
      });
    },
    [lookup, track, eventBundle],
  );
};
